// extracted by mini-css-extract-plugin
export default {"title":"_0c997f25dd","bld":"_75ca0201bc"};